import { createRouter, createWebHistory, START_LOCATION } from 'vue-router'
import routes from './routes'
import { useUserStore } from '@/stores'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior: to => {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 90,
      }
    }
  },
  routes,
})

router.beforeEach(async (to, from) => {
  if (from === START_LOCATION) {
    // 一番最初のみ実行する処理はここに書く
  }

  const userStore = useUserStore()
  await userStore.fetchHash()
  await userStore.fetchUser()

  if (to.path === '/') {
    // トップページの場合
    if (userStore.data) {
      // ログインしていたらマイページへ飛ばす
      return 'mypage'
    }
  }

  if (to.path === '/logged-out') {
    // ログアウト完了ページの場合
    if (!userStore.loggedOutData) {
      // ログアウトした直後ではなかったらトップへ飛ばす
      return '/'
    }
  }

  if (to.matched.some(record => record.meta.requireAuth)) {
    // ログインが必要なページの場合
    if (!userStore.data) {
      // ログインしていない場合は最初の画面へ飛ばす
      // 開発環境と本番環境で遷移先を変えている
      return process.env.NODE_ENV === 'production' ? '/../' : '/'
    }
  }
})

export default router
